import React from "react";
import { Box, Chip, alpha, useTheme } from "@mui/material";
import { Grass, Spa, LocalFireDepartment } from "@mui/icons-material";

/**
 * DietaryFilters Component
 * Displays filter chips for vegetarian, vegan, and spicy items
 */
const DietaryFilters = ({ filters, onFilterChange }) => {
  const theme = useTheme();

  const filterOptions = [
    {
      key: "isVegetarian",
      label: "Vegetarian",
      icon: Grass,
      color: theme.palette.success.main,
    },
    {
      key: "isVegan",
      label: "Vegan",
      icon: Spa,
      color: theme.palette.success.dark,
    },
    {
      key: "isSpicy",
      label: "Spicy",
      icon: LocalFireDepartment,
      color: theme.palette.error.main,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        mb: 1.5,
        flexWrap: "wrap",
      }}
    >
      {filterOptions.map((option) => {
        const Icon = option.icon;
        const isActive = filters[option.key];

        return (
          <Chip
            key={option.key}
            icon={<Icon sx={{ fontSize: 16 }} />}
            label={option.label}
            onClick={() => onFilterChange(option.key)}
            sx={{
              cursor: "pointer",
              bgcolor: isActive
                ? alpha(option.color, 0.15)
                : alpha(theme.palette.divider, 0.05),
              border: isActive
                ? `2px solid ${option.color}`
                : `1px solid ${alpha(theme.palette.divider, 0.2)}`,
              color: isActive ? option.color : "text.secondary",
              fontWeight: isActive ? 600 : 500,
              transition: "all 0.2s ease",
              "& .MuiChip-icon": {
                color: isActive ? option.color : "text.secondary",
              },
              "&:hover": {
                bgcolor: alpha(option.color, 0.1),
                borderColor: option.color,
                transform: "translateY(-2px)",
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default DietaryFilters;
